import type { AxiosResponse } from 'axios';
import { ApiService } from '@/services/api';
import type { getGuarantorsType } from './types';

type useGuarantorType = {
  updateGuarantor: (
    clientId: string,
    guarantorId: string,
    selectionProcessId: string,
    body: getGuarantorsType,
  ) => Promise<AxiosResponse<getGuarantorsType>>;
  createGuarantor: (
    clientId: string,
    selectionProcessId: string,
    body: getGuarantorsType,
  ) => Promise<AxiosResponse<getGuarantorsType>>;
  deleteGuarantors: (
    clienteId: string,
    selectionProcessid: string,
  ) => Promise<AxiosResponse>;
  getGuarantors: (
    clientId: string,
  ) => Promise<AxiosResponse<getGuarantorsType[]>>;
};

function useGuarantor(): useGuarantorType {
  const { api } = ApiService();

  function updateGuarantor(
    clientId: string,
    guarantorId: string,
    selectionProcessId: string,
    body: getGuarantorsType,
  ) {
    return api.put<getGuarantorsType>(
      `/fintech/v1/clients/${clientId}/guarantors/${guarantorId}`,
      { ...body, selection_process_id: selectionProcessId },
    );
  }

  function createGuarantor(
    clientId: string,
    selectionProcessId: string,
    body: getGuarantorsType,
  ) {
    return api.post<getGuarantorsType>(
      `/fintech/v1/clients/${clientId}/guarantors`,
      {
        ...body,
        selection_process_id: selectionProcessId,
      },
    );
  }

  function deleteGuarantors(clienteId: string, selectionProcessid: string) {
    return api.delete(`/fintech/v1/clients/${clienteId}/guarantors`, {
      data: { selection_process_id: selectionProcessid },
    });
  }

  function getGuarantors(clientId: string) {
    return api.get<getGuarantorsType[]>(
      `/fintech/v1/clients/${clientId}/guarantors/`,
    );
  }

  return { updateGuarantor, createGuarantor, getGuarantors, deleteGuarantors };
}

export default useGuarantor;
